import { schema } from 'normalizr';

export const appQrRelation = new schema.Entity('appQrRelations');
export const appQrRelations = new schema.Array(appQrRelation);
